module.exports = __webpack_public_path__ + "static/media/amex.d4cb2c82.svg";